module.exports = __webpack_public_path__ + "img/img_user_2.a6ef1bf9.png";